import React from 'react';

import { OriginalBudgetLeftChart } from './OriginalBudgetLeftChart';
import { OriginalBudgetMainChart } from './OriginalBudgetMainChart';
import { Legend } from './Legend';
import { CHART_COLORS, getMonthCategories } from './utils';
import {
	Section,
	Title,
	ChartWrapper,
	ArrowRight,
	ArrowWrapper,
	SubHeaderWrapper,
} from './BudgetOverview.styles';

const CATEGORIES = ['Savings target', 'Var. to Budget', 'YTD Savings'];

export const FirstChartSection = ({ axisTitle, data, spendFormatter }) => {
	const {
		overallSavingsTarget,
		overallYtdSavings,
		overallVariance,
		monthlyYtdSavings,
		monthlySavingsTarget,
	} = data;

	const getTotalSeriesData = () => {
		const isBudgetOverrun = overallVariance < 0;
		const varianceThreshold = isBudgetOverrun
			? overallSavingsTarget
			: overallYtdSavings;

		return [
			{
				data: [
					{
						name: CATEGORIES[0],
						color: CHART_COLORS.GREY,
						low: 0,
						high: overallSavingsTarget,
					},
					{
						name: CATEGORIES[1],
						color: isBudgetOverrun ? CHART_COLORS.RED : CHART_COLORS.GREEN,
						low: varianceThreshold - Math.abs(overallVariance),
						high: varianceThreshold,
					},
					{
						name: CATEGORIES[2],
						color: CHART_COLORS.TEAL,
						low: 0,
						high: overallYtdSavings,
					},
				],
			},
		];
	};

	const getMainSeriesData = () => {
		const seriesData = monthlyYtdSavings.map((value, index) => ({
			y: value,
			target: monthlySavingsTarget[index],
			color:
				value < 0 || value < monthlySavingsTarget[index]
					? CHART_COLORS.RED
					: CHART_COLORS.GREEN,
		}));

		return [{ data: seriesData }];
	};

	return (
		<Section>
			<Title>Original Budget vs. Actuals: Cumulative Savings Summary</Title>
			<SubHeaderWrapper>
				<Legend />
			</SubHeaderWrapper>
			<ChartWrapper>
				<OriginalBudgetLeftChart
					series={getTotalSeriesData()}
					spendFormatter={spendFormatter}
					title={axisTitle}
				/>
				<ArrowWrapper>
					<ArrowRight />
				</ArrowWrapper>
				<OriginalBudgetMainChart
					categories={getMonthCategories(monthlyYtdSavings.length)}
					series={getMainSeriesData()}
					spendFormatter={spendFormatter}
					title={axisTitle}
				/>
			</ChartWrapper>
		</Section>
	);
};
